import * as React from "react";

import { cn } from "@/lib/utils";

function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
    return (
        <textarea
            data-slot="textarea"
            className={cn(
                "placeholder:text-md-on-surface-placeholder focus-visible:border-md-primary focus-visible:bg-md-surface aria-invalid:border-md-error aria-invalid:bg-md-error/5 flex field-sizing-content min-h-16 w-full rounded-[var(--color-radius)] border border-md-outline bg-md-surface px-3 py-2 text-base transition-colors outline-none disabled:cursor-not-allowed disabled:opacity-30 hover:border-md-primary/50 md:text-sm",
                className
            )}
            {...props}
        />
    );
}

export { Textarea };
